import RemoveStudyPersonnel from './RemoveStudyPersonnel';

export default RemoveStudyPersonnel;
